import { TextScale } from 'particles/Text'
import { Theme } from 'particles/themes'

export function getAlignItems(theme: Theme, textScale?: TextScale, containerHeight?: number) {
    return containerHeight &&
        textScale &&
        containerHeight > Number(theme.textScale[textScale].lineHeight.split('px')[0])
        ? 'start'
        : 'center'
}
